import { createEventDefinition, EventBus } from 'ts-bus';

export { createEventDefinition };

export const localEventBus = new EventBus();
